// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import React, {PropTypes} from 'react';
import Dropdown from './dropdown';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';

const CountriesDropdown = ({onItemChange, countries, statusChangeRequest}) => {

    const status = statusChangeRequest.newStatus.key;

    return (
        <div className='labeled-string'>
            <span className='data-label'>
                <sup>{status === 'STL1' ? '*' : null}</sup> <FormattedMessage id='COUNTRY'/>
            </span>
            <Dropdown
                data={countries}
                name='country'
                onItemChange={onItemChange}
                text='SELECT_COUNTRY'
                value='SELECT_COUNTRY'
            />
        </div>
    );

};

CountriesDropdown.displayName = 'CountriesDropdown';
CountriesDropdown.propTypes = {
    countries: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onItemChange: PropTypes.func.isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default CountriesDropdown;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/dropdowns/countries-dropdown.js